import React, { useState } from 'react';
import { crearEvento } from '../services/eventoService';
import { eventoCreateSchema } from '../utils/validation';
import FieldError from '../utils/FieldError';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale } from 'react-datepicker';
import { es } from 'date-fns/locale/es';

registerLocale('es', es);

const RegistroEvento = ({ onEventoCreado }) => {
    const [form, setForm] = useState({
        fechaHoraEvento: '',
        precioTotalDelEvento: '',
        senaPagada: '',
        cantidadInvitados: '',
        correoResponsable: '',
        telefonoResponsable: '',
        talleCumplaniero: '',
        asistenciaMenores: false,
        tematica: '',
    });
    const [errors, setErrors] = useState({});
    const [mensaje, setMensaje] = useState('');
    const [fechaDate, setFechaDate] = useState(null);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
        if (errors[name]) setErrors((prev) => ({ ...prev, [name]: undefined }));
    };

    const handleDateChange = (date) => {
        setFechaDate(date);
        if (date) {
            const pad = (n) => String(n).padStart(2, '0');
            const iso = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
            setForm((prev) => ({ ...prev, fechaHoraEvento: iso }));
        } else {
            setForm((prev) => ({ ...prev, fechaHoraEvento: '' }));
        }
        if (errors.fechaHoraEvento) setErrors((prev) => ({ ...prev, fechaHoraEvento: undefined }));
    };

    const formatDateTimeForView = (value) => {
        if (!value) return '';
        const d = new Date(value);
        return d.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            ...form,
            precioTotalDelEvento: Number(form.precioTotalDelEvento),
            senaPagada: form.senaPagada ? Number(form.senaPagada) : 0,
            cantidadInvitados: Number(form.cantidadInvitados),
        };
        const result = eventoCreateSchema.safeParse(payload);
        if (!result.success) {
            const fieldErrors = {};
            result.error.issues.forEach((i) => { fieldErrors[i.path[0]] = i.message; });
            setErrors(fieldErrors);
            return;
        }
        try {
            const [datePart, timePart] = result.data.fechaHoraEvento.split('T');
            const [year, month, day] = datePart.split('-').map(Number);
            const [hour, minute] = timePart.split(':').map(Number);
            const fechaISO = `${year}-${String(month).padStart(2,'0')}-${String(day).padStart(2,'0')}T${String(hour).padStart(2,'0')}:${String(minute).padStart(2,'0')}`;

            await crearEvento({
                ...result.data, fechaHoraEvento: fechaISO,
                senaPagada: result.data.senaPagada || 0,
            });
            setMensaje('Evento creado exitosamente');
            setForm({ fechaHoraEvento: '', precioTotalDelEvento: '', senaPagada: '', cantidadInvitados: '', correoResponsable: '', telefonoResponsable: '', talleCumplaniero: '', asistenciaMenores: false, tematica: '' });
            setFechaDate(null);
            setErrors({});
            if (onEventoCreado) onEventoCreado();
        } catch (err) {
            setMensaje(err?.response?.data?.mensaje || 'Error al crear evento');
        }
    };

    return (
        <form className="bg-white border border-gray-200 rounded-lg shadow-sm p-5 space-y-4" onSubmit={handleSubmit}>
            <h3 className="text-base font-semibold text-gray-900">Registrar Evento</h3>

            <div className="space-y-1">
                <label className="block text-sm font-medium text-gray-700">Fecha y hora:</label>
                <DatePicker selected={fechaDate} onChange={handleDateChange} showTimeSelect dateFormat="Pp" locale="es" timeIntervals={15} placeholderText="Seleccionar fecha y hora"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
                <FieldError message={errors.fechaHoraEvento} />
                {fechaDate && <p className="text-xs text-gray-500">Seleccionado: <strong>{formatDateTimeForView(form.fechaHoraEvento)}</strong></p>}
            </div>

            <div className="grid grid-cols-2 gap-3">
                <div className="space-y-1">
                    <label className="block text-sm font-medium text-gray-700">Precio total:</label>
                    <input type="number" name="precioTotalDelEvento" value={form.precioTotalDelEvento} onChange={handleChange} placeholder="Precio total" required
                        className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
                    <FieldError message={errors.precioTotalDelEvento} />
                </div>
                <div className="space-y-1">
                    <label className="block text-sm font-medium text-gray-700">Seña pagada:</label>
                    <input type="number" name="senaPagada" value={form.senaPagada} onChange={handleChange} placeholder="Seña"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
                </div>
            </div>

            <div className="space-y-1">
                <label className="block text-sm font-medium text-gray-700">Cantidad de invitados:</label>
                <input type="number" name="cantidadInvitados" value={form.cantidadInvitados} onChange={handleChange} placeholder="Cantidad" required
                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
                <FieldError message={errors.cantidadInvitados} />
            </div>

            <div className="grid grid-cols-2 gap-3">
                <div className="space-y-1">
                    <label className="block text-sm font-medium text-gray-700">Correo responsable:</label>
                    <input type="email" name="correoResponsable" value={form.correoResponsable} onChange={handleChange} placeholder="Correo" required
                        className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
                    <FieldError message={errors.correoResponsable} />
                </div>
                <div className="space-y-1">
                    <label className="block text-sm font-medium text-gray-700">Teléfono responsable:</label>
                    <input type="text" name="telefonoResponsable" value={form.telefonoResponsable} onChange={handleChange} placeholder="Teléfono"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
                </div>
            </div>

            <div className="grid grid-cols-2 gap-3">
                <div className="space-y-1">
                    <label className="block text-sm font-medium text-gray-700">Talle cumpleañero:</label>
                    <input type="text" name="talleCumplaniero" value={form.talleCumplaniero} onChange={handleChange} placeholder="Talle"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
                </div>
                <div className="flex items-end pb-2">
                    <label className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
                        <input type="checkbox" name="asistenciaMenores" checked={form.asistenciaMenores} onChange={handleChange}
                            className="rounded border-gray-300 text-primary-600 focus:ring-primary-500" />
                        Menores
                    </label>
                </div>
            </div>

            <div className="space-y-1">
                <label className="block text-sm font-medium text-gray-700">Temática:</label>
                <input type="text" name="tematica" value={form.tematica} onChange={handleChange} placeholder="Temática" required
                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
                <FieldError message={errors.tematica} />
            </div>

            <button type="submit" className="w-full py-2.5 px-4 bg-primary-600 text-white text-sm font-medium rounded-md hover:bg-primary-700 transition-colors">Crear</button>

            {mensaje && <p className="text-sm text-center font-medium text-gray-700 bg-gray-50 border border-gray-200 rounded-md px-3 py-2">{mensaje}</p>}
        </form>
    );
};

export default RegistroEvento;
